import { render, staticRenderFns } from "./transferListModal.vue?vue&type=template&id=584ace4a&scoped=true&"
import script from "./transferListModal.vue?vue&type=script&lang=js&"
export * from "./transferListModal.vue?vue&type=script&lang=js&"
import style0 from "./transferListModal.vue?vue&type=style&index=0&id=584ace4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584ace4a",
  null
  
)

export default component.exports